import { Box, Button, Typography } from '@mui/material';
import { FC, useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { ESortDirection, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { getEmManagementListRequest } from 'redux/reducers/emManagement/reducer';
import { PAGE_SIZE } from 'services/constants/env';
import {
	getEmManagementListData,
	getEmManagementListLoading,
} from 'redux/reducers/emManagement/selectors';
import { TEmManagementListResponseItem } from 'redux/reducers/emManagement/types';
import { TFilters, TOrderBy } from 'redux/types';
import { DATES_ARRAY, DATES_ID } from 'services/constants/dates-constants';
import { EasTableWithFilter } from 'ui/EasTableWithFilter';
import { tableStructure } from './tableStructureNew';
import { saveUrl } from '../../redux/reducers/auth/reducer';
import { PATHS } from '../../routes/constants';
import { getFiltersFromNavigateParams } from '../../utils/FilterParams';

export const EMManagement: FC = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { search } = useLocation();
	const navigateParams = queryString.parse(search);
	const { page } = queryString.parse(search);
	const [currentTableStructure, setCurrentTableStructure] = useState(tableStructure);
	const emManagementList = useSelector(getEmManagementListData);
	const emManagementListLoading = useSelector(getEmManagementListLoading);

	const handleTableStructureChange = useCallback(
		(newTableStructure: TTableStructure<keyof TEmManagementListResponseItem>[]) => {
			setCurrentTableStructure(newTableStructure);
		},
		[],
	);

	// const navigateParamsWithoutPage = tableStructure.reduce((acc, item) => {
	// 	if (!!navigateParams[item.selector] && item.type === ETableStructureType.DATE) {
	// 		if (navigateParams[item.selector] === DATES_ID.CUSTOM_RANGE) {
	// 			if (navigateParams[`${item.selector}StartDate`]) {
	// 				acc.push({
	// 					fieldName: item.selector,
	// 					value: navigateParams[`${item.selector}StartDate`] as string,
	// 					operator: '>=',
	// 				});
	// 			}
	// 			if (navigateParams[`${item.selector}EndDate`]) {
	// 				acc.push({
	// 					fieldName: item.selector,
	// 					value: navigateParams[`${item.selector}EndDate`] as string,
	// 					operator: '<=',
	// 				});
	// 			}
	// 			return acc;
	// 		}
	// 		const dates = DATES_ARRAY.find((i) => i.id === navigateParams[item.selector]);
	// 		// console.log('dates', dates);
	// 		if (dates?.from) {
	// 			acc.push({
	// 				fieldName: item.selector,
	// 				value: dates.from,
	// 				operator: '>=',
	// 			});
	// 		}
	// 		if (dates?.to) {
	// 			acc.push({
	// 				fieldName: item.selector,
	// 				value: dates.to,
	// 				operator: '<=',
	// 			});
	// 		}
	// 		return acc;
	// 	}
	// 	if (navigateParams[item.selector])
	// 		acc.push({
	// 			fieldName: item.selector,
	// 			value: navigateParams[item.selector] as string,
	// 			operator: '=',
	// 		});
	// 	return acc;
	// }, [] as TFilters);

	const navigateParamsWithoutPage = getFiltersFromNavigateParams(
		currentTableStructure,
		navigateParams,
	) as TFilters;
	useEffect(() => {
		const orderBy = [];
		if (navigateParams?.sortIndex) {
			orderBy.push({
				fieldName: navigateParams?.sortIndex
					? tableStructure[+navigateParams.sortIndex].selector
					: 'id',
				direction: navigateParams?.sortDirection
					? String(navigateParams.sortDirection) === 'desc'
						? ESortDirection.DESC
						: ESortDirection.ASC
					: ESortDirection.DESC,
			} as TOrderBy);
		}
		orderBy.push({
			fieldName: 'id',
			direction: ESortDirection.DESC,
		} as TOrderBy);
		dispatch(
			getEmManagementListRequest({
				pageNumber: page ? +page : 1,
				pageSize: PAGE_SIZE,
				searchString: String(navigateParams?.search ?? ''),
				filters: navigateParamsWithoutPage,
				orderBy,
			}),
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, search]);

	const handleLink = (id: number) => {
		dispatch(saveUrl(window.location.pathname + window.location.search));
		navigate(`/em-management/${id}`);
	};

	return (
		<Box sx={{ margin: '0px 10px 0 10px' }}>
			<EasTableWithFilter<TEmManagementListResponseItem>
				tableStructure={currentTableStructure}
				items={emManagementList}
				itemsIsLoading={emManagementListLoading}
				handleAction={() => {}}
				onTableStructureChange={handleTableStructureChange}
				handleLink={handleLink}
			>
				<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography variant="body1" color="primary" fontWeight="bold">
						EM Management
					</Typography>
					<Button
						variant="contained"
						color="primary"
						size="small"
						onClick={() => navigate(PATHS.EM_MANAGEMENT_CREATE_PAGE)}
					>
						Create EM
					</Button>
				</Box>
			</EasTableWithFilter>
		</Box>
	);
};
